module.exports = __webpack_public_path__ + "media/images/masks/avatar-group-hover-7dccee21ac9e2843f4ba1f3ec9972613a26ad4bd34cf5514fd4bc86636316de9.svg";